module.exports = __webpack_public_path__ + "img/kutxabank.334ceb82.png";